<template>
	<div class="container">
		<div v-if="showVote">
			<h1>{{ currentPage.title }}</h1>
			<choices :selectable="true"
			         class="choices"
			         v-bind:choices="choices"
			         v-bind:value="activeChoiceIndex"
			         v-on:value="activeChoiceIndex = $event; onClickAnswer();"/>
		</div>
		<div class="center" v-else-if="currentMediaUrl">
			<h1>{{$t('game.studentWaiting')}}</h1>
			<div class="media-container">
				<img :src="currentMediaUrl" />
			</div>
		</div>
		<div class="center" v-else>
			<h1>{{$t('game.studentWaiting')}}</h1>
		</div>
	</div>
</template>

<script>
	import PagePhase from '@/enum/PagePhase'
	import {mapGetters} from 'vuex'
	import LoadingIndicator from '@/components/loading-indicator'
	import AppButton from '@/components/app-button'
	import Choices from '@/components/choices'
	import ThingToHtml from '../../../../lib/ThingToHtmlVue/thing-to-html'
	import {getStudentUrl} from '@/utils/UrlUtil'

	export default {
		components: {
			ThingToHtml,
			Choices,
			AppButton,
			LoadingIndicator
		},
		data() {
			return {
				activeChoiceIndex: -1,
				sentVote: false,
				currentMediaUrl: null
			}
		},
		watch: {
			currentPagePhase(currentPagePhase) {
				if (currentPagePhase === PagePhase.Result) {
					// Reset sent vote
					this.sentVote = false
				}

				this.reloadImageUrl();
			},
			currentPage(currentPage) {
				this.reloadImageUrl();
			}
		},
		computed: {
			...mapGetters({
				currentTheme: 'getCurrentTheme',
				currentCase: 'getCurrentCase',
				currentGamePhase: 'getCurrentGamePhase',
				currentPageIndex: 'getCurrentPageIndex',
				currentPagePhase: 'getCurrentPagePhase',
			}),
			currentPage() {
				if (!this.currentCase) {
					return null;
				}

				if (this.currentCase.pages.length < this.currentPageIndex - 1) {
					return null;
				}

				return this.currentCase.pages[this.currentPageIndex];
			},
			currentPageComponents() {
				if (!this.currentPage) {
					return null;
				}

				if (!this.currentPage.components) {
					return null;
				}

				return this.currentPage.components;
			},
			leftComponentType() {
				if (!this.currentPageComponents) {
					return null;
				}

				if (!this.currentPageComponents.left) {
					return null;
				}

				return this.currentPageComponents.left.component;
			},
			rightComponentType() {
				if (!this.currentPageComponents) {
					return null;
				}

				if (!this.currentPageComponents.right) {
					return null;
				}

				return this.currentPageComponents.right.component;
			},
			isChoiceComponent() {
				return this.leftComponentType === 'Choices' || this.rightComponentType === 'Choices';
			},
			choiceComponentOptions() {
				if (this.leftComponentType === 'Choices') {
					return this.currentPageComponents.left.options;
				} else if (this.rightComponentType === 'Choices') {
					return this.currentPageComponents.right.options;
				}

				return null;
			},
			showVote() {
				return this.isChoiceComponent && this.currentPagePhase === PagePhase.Normal && !this.sentVote;
			},
			choices() {
				if (!this.choiceComponentOptions) {
					return [];
				}

				return this.choiceComponentOptions.choices;
			}
		},
		methods: {
			reloadImageUrl() {
				let mediaUrl = null;

				if (this.currentPageComponents && this.currentPagePhase === PagePhase.Normal) {
					for (let side in this.currentPageComponents) {
						let component = this.currentPage.components[side].component;
						let componentOptions = this.currentPage.components[side].options;

						if (component === 'RawMedia' || component === 'Media') {
							if (componentOptions.media) {
								mediaUrl = this.$apiClient.baseUrl + '/uploads/' + componentOptions.media.replace(/^\/+/, '');

								break;
							}
						}
					}
				}

				this.currentMediaUrl = mediaUrl;
			},
			onClickAnswer() {
				if (this.sentVote) {
					return
				}

				if (this.activeChoiceIndex < 0) {
					return
				}

				this.$gameClient.send({
					currentVote: this.activeChoiceIndex
				})

				this.sentVote = true
			}
		},
		mounted() {
			if (this.$gameClient == null || !this.$gameClient.isConnected || !this.$gameClient.inRoom()) {
				this.$router.push(getStudentUrl('connect'))
				return
			}

			if (!this.currentCase) {
				console.log('Could not find a current case - going back to index')

				this.$router.push(getStudentUrl('connect'))
			}

			this.reloadImageUrl();
		}
	}
</script>

<style lang="less" scoped>
	.center {
		position: absolute;
		top: 50%;
		text-align: center;
		width: 100%;
		left: 0;
		transform: translate(0, -50%);
		padding: 0 20px;
	}

	.answer-button-container {
		margin-top: 50px;
		text-align: center;
	}

	.media-container {
		img {
			max-width: 100%;
			max-height: 300px;
		}
	}
</style>
